import { UserAddress } from "../../store/slice/userSlice";
import "./AddressForm.scss";
import React, { useState } from "react";

type AddAddressFormProps = {
  onSubmit: (form: Partial<UserAddress>) => void;
  onCancel: () => void;
  typeForm: "create" | "update";
  idAddress?: string;
  address?: UserAddress;
};

const AddAddressForm: React.FC<AddAddressFormProps> = ({
  onSubmit,
  onCancel,
  typeForm,
  idAddress,
  address,
}) => {
  const [form, setForm] = useState<Omit<UserAddress, "id">>({
    fullName: "",
    addressLine1: "",
    addressLine2: "",
    postalCode: "",
    city: "",
    country: "",
    phone: "",
    isDefaultShipping: false,
    isDefaultBilling: false,
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type, checked } = e.target as any;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(typeForm === "update" ? { ...form, id: idAddress } : form);
  };

  return (
    <form className="address-form" onSubmit={handleSubmit}>
      <input
        type="text"
        name="fullName"
        placeholder="Nom complet"
        value={form.fullName}
        onChange={handleChange}
        required
      />
      <input
        type="text"
        name="addressLine1"
        placeholder="N° et nom de voie"
        value={form.addressLine1}
        onChange={handleChange}
        required
      />
      <input
        type="text"
        name="addressLine2"
        placeholder="Complément d’adresse"
        value={form.addressLine2}
        onChange={handleChange}
      />
      <div className="form-row">
        <input
          type="text"
          name="postalCode"
          placeholder="Code postal"
          value={form.postalCode}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="city"
          placeholder="Ville"
          value={form.city}
          onChange={handleChange}
          required
        />
      </div>
      <input
        type="text"
        name="country"
        placeholder="Pays"
        value={form.country}
        onChange={handleChange}
        required
      />
      <input
        type="tel"
        name="phone"
        placeholder="Numéro de téléphone"
        value={form.phone}
        onChange={handleChange}
        required
      />
      <div className="checkbox-group">
        <label>
          <input
            type="checkbox"
            name="isDefaultShipping"
            checked={form.isDefaultShipping}
            onChange={handleChange}
          />
          Adresse de livraison par défaut.
        </label>
        <label>
          <input
            type="checkbox"
            name="isDefaultBilling"
            checked={form.isDefaultBilling}
            onChange={handleChange}
          />
          Adresse de facturation par défaut.
        </label>
      </div>
      <div className="button-group">
        <button type="button" className="cancel" onClick={onCancel}>
          Annuler
        </button>
        <button type="submit" className="save">
          Enregistrer
        </button>
      </div>
    </form>
  );
};

export default AddAddressForm;
